import SearchRangeComponents from './SearchRangeComponents';
import SearchRangeComponentsValidation from './validation';

export {
    SearchRangeComponentsValidation
};

export default SearchRangeComponents;
